// extracted by mini-css-extract-plugin
export default {"menuTitle":"BaseOverlayMenuListTitlePhase2-9_menuTitle_Db6Tb"};